/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelInfoArrayResultApiResult } from '../../models/hotel-info-array-result-api-result';

export interface ApiHotelListGet$Params {
}

export function apiHotelListGet(http: HttpClient, rootUrl: string, params?: ApiHotelListGet$Params, context?: HttpContext): Observable<StrictHttpResponse<HotelInfoArrayResultApiResult>> {
  const rb = new RequestBuilder(rootUrl, apiHotelListGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HotelInfoArrayResultApiResult>;
    })
  );
}

apiHotelListGet.PATH = '/api/hotel/list';
